import React, { useEffect } from "react";
import useCalendarSale from "./hooks/useCalendarSale";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "../../../style/typography.scss";
import "../../../style/calendar.scss";
import SingleAvailAbleExercise from "./single-exercise";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useFacility from "../../../utils/hooks/useFacility";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import { checkComponentActive } from "../../../utils/checkComponentActive";
import EAAlert from "../shared/EAAlert";
import { useTranslation } from "react-i18next";

const CalendarSale: React.FC = () => {
  const { t } = useTranslation();
  const { getExercisesAvailable, exerciseAvailAble, loading } = useCalendarSale();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  useEffect(() => {
    getExercisesAvailable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  if (checkComponentActive(saleConfiguration.componentList, "StepByStepSaleActiveV2") === false) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  }

  return (
    <div>
      <EAPageHeader componentId="StepByStepSaleActiveV2" />
      <EAPageMessage message={saleConfiguration.message_stepByStep} />

      <div className="exercise-available-wrapper">
        {loading ? (
          <EASkeletonLoader height="200px" />
        ) : (
          <>
            {exerciseAvailAble && (
              <>
                {exerciseAvailAble.map((exercise) => (
                  <SingleAvailAbleExercise key={exercise.objectId} exercise={exercise} />
                ))}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CalendarSale;
